import React from 'react';
import PropTypes from 'prop-types';
import closeIcon from '@assets/icons/close.svg';
import Icon from '@components/Input/components/Icon';

const CleanIcon = ({ onClick }) => (
  <Icon onClick={onClick}>
    <img src={closeIcon} />
  </Icon>
);

CleanIcon.propTypes = {
  onClick: PropTypes.func,
};

export default CleanIcon;
